import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import OrderModal from '../components/OrderModal';

const apexProducts = [
  {
    category: "BADGE BOT LOBBIES",
    subtitle: "4K/20 & 10-10-10 Badges",
    items: [
      { name: "1 AFK LOBBY", price: "$20.00", url: "https://buy.stripe.com/3cI9ATbBT4eJePO9dFbV600" },
      { name: "2 AFK LOBBIES", price: "$35.00", url: "https://buy.stripe.com/aFa7sL35nh1v2321LdbV613" },
      { name: "3 AFK LOBBIES", price: "$45.00", url: "https://buy.stripe.com/8x2aEX49raD76ji2PhbV614" },
      { name: "4 AFK LOBBIES", price: "$60.00", url: "https://buy.stripe.com/3cI4gz49r12xazy0H9bV615" },
      { name: "5 AFK LOBBIES", price: "$75.00", url: "https://buy.stripe.com/3cI28r8pH4eJ6ji2PhbV616" },
      { name: "10 AFK LOBBIES", price: "$125.00", url: "https://buy.stripe.com/00waEX49rdPjazyahJbV617" },
      { name: "15 AFK LOBBIES", price: "$150.00", url: "https://buy.stripe.com/bJe4gz9tL12xazy4XpbV618" },
      { name: "25 AFK LOBBIES", price: "$200.00", url: "https://buy.stripe.com/14A00j9tL12xazy3TlbV619" },
      { name: "10-10-10 BADGE", price: "$40.00", url: "https://buy.stripe.com/14AdR95dv5iNfTS75xbV60u" }
    ]
  },
  {
    category: "PREDATOR HOLDS",
    items: [
      { name: "1 SPLIT", price: "$280.00", url: "https://buy.stripe.com/3cI28rbBTfXr5feblNbV61w", description: "Guaranteed Predator Badge" },
      { name: "2 SPLITS", price: "$500.00", url: "https://buy.stripe.com/6oUaEX49r8uZePO2PhbV61x", description: "Guaranteed Animated Predator Badge" }
    ]
  },
  {
    category: "RANKED BOOSTS",
    subcategories: [
      {
        name: "Master & Predator Points",
        items: [
          { name: "1000 RANKED POINTS (MASTERS & PREDATOR ONLY)", price: "$40.00", url: "https://buy.stripe.com/7sYfZh9tLfXr6jicpRbV61B" }
        ]
      },
      {
        name: "Diamond Packages",
        items: [
          { name: "GOLD → DIAMOND", price: "$55.00", url: "https://buy.stripe.com/7sYeVdfS99z3cHG75xbV60B" },
          { name: "PLATINUM → DIAMOND", price: "$45.00", url: "https://buy.stripe.com/3cIeVdfS95iNgXWcpRbV60C" }
        ]
      },
      {
        name: "Masters Packages",
        items: [
          { name: "GOLD → MASTERS", price: "$155.00", url: "https://buy.stripe.com/cNi6oHfS94eJfTS0H9bV61y" },
          { name: "PLATINUM → MASTERS", price: "$140.00", url: "https://buy.stripe.com/aFa7sL21jfXrePO4XpbV61z" },
          { name: "DIAMOND → MASTERS", price: "$125.00", url: "https://buy.stripe.com/aFa00jaxP8uZazydtVbV61A" }
        ]
      }
    ]
  }
];

const ApexPage = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Scroll to hash section on load
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [location.hash]);

  const handleOrderClick = (item) => {
    const token = localStorage.getItem('token');
    if (!token) {
      // Save intended product in session storage
      sessionStorage.setItem('intendedOrder', JSON.stringify({ product: item, page: 'apex' }));
      navigate('/login');
      return;
    }
    setSelectedProduct(item);
    setIsModalOpen(true);
  };

  // Check if returning from login with intended order
  useEffect(() => {
    const intendedOrder = sessionStorage.getItem('intendedOrder');
    if (intendedOrder) {
      const { product, page } = JSON.parse(intendedOrder);
      if (page === 'apex') {
        sessionStorage.removeItem('intendedOrder');
        setSelectedProduct(product);
        setIsModalOpen(true);
      }
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0f172a] text-[#f8fafc]">
      <Navbar />
      
      {/* Hero */}
      <section className="relative py-56 md:py-72 overflow-hidden min-h-[600px]">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-[#0f172a] z-10"></div>
          <video 
            src="/images/best20bomb.webm"
            autoPlay loop muted playsInline
            className="w-full h-full object-cover object-center opacity-50"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center pt-16">
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter uppercase mb-6" data-testid="apex-hero-title">
            <span className="text-red-500">APEX LEGENDS</span> SERVICES
          </h1>
          <p className="text-xl text-slate-400 font-['Rajdhani'] tracking-wide">
            Professional boosting services for badges, ranks, and scripts
          </p>
        </div>
      </section>

      {/* Products */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-24">
          {apexProducts.map((category, catIndex) => (
            <div key={catIndex} id={category.category === "BADGE BOT LOBBIES" ? "badge-bot-lobbies" : category.category === "PREDATOR HOLDS" ? "predator-holds" : category.category === "RANKED BOOSTS" ? "ranked-boosts" : undefined} data-testid={`category-${catIndex}`} className="border-t border-white/10 pt-12 first:border-t-0 first:pt-0">
              <h2 className="text-3xl md:text-5xl mb-2 text-red-500 tracking-wider font-['Bangers'] drop-shadow-[3px_3px_0px_rgba(0,0,0,0.8)] flex items-center gap-4">
                {category.category === "BADGE BOT LOBBIES" && (
                  <img 
                    src="/images/20bomb.png"
                    alt="20 Bomb Badge"
                    className="w-12 h-12 md:w-16 md:h-16"
                  />
                )}
                {category.category === "PREDATOR HOLDS" && (
                  <img 
                    src="/images/ranked-symbol-2.png"
                    alt="Predator Symbol"
                    className="w-12 h-12 md:w-16 md:h-16"
                  />
                )}
                {category.category}
                {category.category === "BADGE BOT LOBBIES" && (
                  <img 
                    src="/images/navbar-logo.png"
                    alt="20 Bomb Badge"
                    className="w-12 h-12 md:w-16 md:h-16"
                  />
                )}
                {category.category === "PREDATOR HOLDS" && (
                  <img 
                    src="/images/ranked-symbol-2.png"
                    alt="Predator Symbol"
                    className="w-12 h-12 md:w-16 md:h-16"
                  />
                )}
              </h2>
              {category.subtitle && (
                <p className="text-lg md:text-xl text-yellow-400 mb-8 tracking-wider font-['Bangers'] drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">{category.subtitle}</p>
              )}
              {category.category === "PREDATOR HOLDS" && (
                <p className="text-lg md:text-xl text-yellow-400 mb-8 tracking-wider font-['Bangers'] drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">Predator Badge Guaranteed</p>
              )}
              {category.category === "RANKED BOOSTS" && (
                <p className="text-lg md:text-xl text-yellow-400 mb-8 tracking-wider font-['Bangers'] drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)]">Ranked on easy mode</p>
              )}
              {category.category === "RANKED BOOSTS" && (
                <div className="bg-[rgba(30,41,59,0.7)] border border-cyan-500 backdrop-blur-xl p-6 md:p-8 rounded-3xl mb-10" data-testid="ranked-boosts-description">
                  <p className="text-slate-300 leading-relaxed mb-4">
                    The first option is a "Traditional Ranked Boost" where one of our pro boosters get on your account and plays until we reach the rank you ordered.
                  </p>
                  <p className="text-slate-300 leading-relaxed mb-4">
                    The second option is a "Ranked Carry", where you play alongside one of our pro boosters until you reach your selected rank, with no account information required.
                  </p>
                  <p className="text-slate-300 leading-relaxed mb-4">
                    The third option is our "Ranked Bot Lobbies", which also requires no account information and are the fastest way to get the rank you ordered.
                  </p>
                  <p className="text-slate-300 leading-relaxed">
                    Note: Ranked Bot Lobbies are not always available due to constant in-game changes. We work hard to keep them available, but availability cannot always be guaranteed. No matter which option you choose, or which options are available when you order, you will always receive the rank you purchased.
                  </p>
                </div>
              )}
              {category.category === "PREDATOR HOLDS" && (
                <div className="bg-[rgba(30,41,59,0.7)] border border-cyan-500 backdrop-blur-xl p-6 md:p-8 rounded-3xl mb-10" data-testid="predator-holds-description">
                  <p className="text-slate-300 leading-relaxed mb-4">
                    Predator Holds are ranked boosts that take you from your current rank all the way to Top #200 Predator or better. We do not just get you to Predator and stop there — we keep you there for the entire split, guaranteeing you a Top #200 Predator Badge, Frame, and Charm!
                  </p>
                  <p className="text-slate-300 leading-relaxed mb-4">
                    You can also choose to order a Predator Hold for the full season instead of just one split. The main difference is that a full-season hold gives you the animated Predator badge. If you only purchase one split, you still receive the same rewards, but the badge will not be animated unless you reach Predator in both splits.
                  </p>
                  <p className="text-slate-300 leading-relaxed">
                    Note: The number shown on your Predator badge will always reflect the highest placement you achieved. For example, if you reach #1 Predator in the first split and #100 Predator in the second split, your badge will show #1.
                  </p>
                </div>
              )}
              {/* Description box for Badge Bot Lobbies */}
              {category.category === "BADGE BOT LOBBIES" && (
                <div className="bg-[rgba(30,41,59,0.7)] border border-cyan-500 backdrop-blur-xl p-6 md:p-8 rounded-3xl mb-10" data-testid="badge-lobbies-description">
                  <p className="text-slate-300 leading-relaxed">
                    Our AFK Bot Lobbies are Safe, Fast, and Easy! Our lobbies guarantee a 4K Damage and 20 Kill badge for a legend of your choice. No account information required and available on all platforms (PlayStation, Xbox, PC, Nintendo Switch) it doesn't matter you just join the lobby and ready up! You get to go in and kill the bots yourself! The more bot lobbies you order the better discount you will get! Order Now!
                  </p>
                </div>
              )}
              
              {/* Regular items */}
              {category.items && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                  {category.items.map((item, itemIndex) => (
                    <div 
                      key={itemIndex}
                      className="bg-[rgba(30,41,59,0.7)] border-2 border-red-500/60 backdrop-blur-xl p-8 rounded-2xl hover:border-red-400 hover:-translate-y-1 transition-all duration-200"
                      data-testid={`product-${catIndex}-${itemIndex}`}
                    >
                      <h3 className="text-2xl font-bold uppercase mb-2 text-white font-['Poppins',sans-serif] flex items-center gap-2">
                        {item.name}
                        {category.category === "BADGE BOT LOBBIES" && item.name.includes("AFK") && (
                          <img 
                            src="/images/4k20bomb.png"
                            alt="4K/20 Badge"
                            className="w-16 h-16 md:w-20 md:h-20"
                          />
                        )}
                        {item.name === "10-10-10 BADGE" && (
                          <img 
                            src="/images/teamwork.png"
                            alt="10-10-10 Badge"
                            className="w-16 h-16 md:w-20 md:h-20"
                          />
                        )}
                      </h3>
                      {item.description && (
                        <p className="text-[10px] text-red-300/60 uppercase tracking-widest mb-4">{item.description}</p>
                      )}
                      <p className="text-3xl font-black text-red-500 mb-6">{item.price}</p>
                      <button 
                        onClick={() => handleOrderClick(item)}
                        data-testid={`order-button-${catIndex}-${itemIndex}`}
                        className="w-full relative overflow-hidden bg-gradient-to-r from-red-700 via-red-600 to-red-500 text-white font-bold py-3 px-6 uppercase tracking-widest transition-all duration-300 rounded-lg text-sm shadow-lg shadow-red-900/50 hover:shadow-red-500/60 hover:scale-[1.02] border border-red-400/30"
                      >
                        <span className="relative z-10">ORDER NOW</span>
                      </button>
                    </div>
                  ))}
                </div>
              )}
              
              {/* Subcategories */}
              {category.subcategories && (
                <div className="space-y-12 mt-8">
                  {category.subcategories.map((sub, subIndex) => (
                    <div key={subIndex}>
                      <h3 className="text-xl md:text-2xl mb-6 text-slate-300 tracking-wider font-['Bangers'] border-l-4 border-red-500 pl-4 drop-shadow-[2px_2px_0px_rgba(0,0,0,0.8)] flex items-center gap-3">
                        {sub.name === "Master & Predator Points" && (
                          <img 
                            src="/images/predator-symbol-2.png"
                            alt="Masters Symbol"
                            className="w-10 h-10 md:w-12 md:h-12"
                          />
                        )}
                        {sub.name === "Masters Packages" && (
                          <img 
                            src="/images/predator-symbol.png"
                            alt="Masters Symbol"
                            className="w-10 h-10 md:w-12 md:h-12"
                          />
                        )}
                        {sub.name === "Diamond Packages" && (
                          <img 
                            src="/images/ranked-symbol.png"
                            alt="Diamond Symbol"
                            className="w-10 h-10 md:w-12 md:h-12"
                          />
                        )}
                        {sub.name}
                        {sub.name === "Master & Predator Points" && (
                          <img 
                            src="/images/master-pred.png"
                            alt="Predator Symbol"
                            className="w-10 h-10 md:w-12 md:h-12"
                          />
                        )}
                        {sub.name === "Masters Packages" && (
                          <img 
                            src="/images/predator-symbol.png"
                            alt="Masters Symbol"
                            className="w-10 h-10 md:w-12 md:h-12"
                          />
                        )}
                        {sub.name === "Diamond Packages" && (
                          <img 
                            src="/images/ranked-symbol.png"
                            alt="Diamond Symbol"
                            className="w-10 h-10 md:w-12 md:h-12"
                          />
                        )}
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {sub.items.map((item, itemIndex) => (
                          <div 
                            key={itemIndex}
                            className="bg-[rgba(30,41,59,0.7)] border-2 border-red-500/60 backdrop-blur-xl p-8 rounded-2xl hover:border-red-400 hover:-translate-y-1 transition-all duration-200"
                            data-testid={`product-${catIndex}-${subIndex}-${itemIndex}`}
                          >
                            <h3 className="text-2xl font-bold uppercase mb-2 text-white font-['Poppins',sans-serif]">{item.name}</h3>
                            {item.description && (
                              <p className="text-[10px] text-red-300/60 uppercase tracking-widest mb-4">{item.description}</p>
                            )}
                            <p className="text-3xl font-black text-red-500 mb-6">{item.price}</p>
                            <button 
                              onClick={() => handleOrderClick(item)}
                              data-testid={`order-button-${catIndex}-${subIndex}-${itemIndex}`}
                              className="w-full relative overflow-hidden bg-gradient-to-r from-red-700 via-red-600 to-red-500 text-white font-bold py-3 px-6 uppercase tracking-widest transition-all duration-300 rounded-lg text-sm shadow-lg shadow-red-900/50 hover:shadow-red-500/60 hover:scale-[1.02] border border-red-400/30"
                            >
                              <span className="relative z-10">ORDER NOW</span>
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <OrderModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={selectedProduct}
      />

      <Footer />
    </div>
  );
};

export default ApexPage;